export default {
  insertMenuTitle: 'Ponuka výrazov',
};
